import styled from 'styled-components';
import colors from 'Styles/colors';
import { slideIn } from 'Styles/effects';
import { ReactComponent as _Warning } from 'Images/warning-delete.svg';
import Button from 'shared/ui/Button';
import { Title as InputTitle } from 'Common/Components/InputString/styled';
import BaseCancelButton from 'shared/ui/CancelButton';

export const ModalContent = styled.div`
  padding: 34px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  border-top: 10px solid ${colors.softBlue};
  background: ${({ theme }) => theme.backgrounds.modal};
  width: 505px;
  ${slideIn}
`;

export const ModalTitle = styled.div`
  display: flex;
  margin-bottom: 21px;
`;

export const Warning = styled(_Warning)`
  path {
    fill: ${({ theme }) => theme.text.modalTitle2};
  }
  align-self: center;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.text.modalTitle2};
  font-weight: 600;
  font-size: 21.5px;
  margin-left: 13px;
`;

export const ModalBody = styled.div`
  text-align: left;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 34px;
`;

export const ConfirmButton = styled(Button)``;

export const CancelButton = styled(BaseCancelButton)`
  margin-right: 10px;
`;

export const RequiredInputWrapper = styled.div`
  ${({ $required }) => $required && `
    ${InputTitle} {
      position: relative;
      display: inline-block;
    }

    ${InputTitle}::after {
      content: ' *';
      color: #ea3158;
      font-weight: 600;
    }
  `}
`;

export const ErrorText = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: #d93025;
`;
